import React, { createContext, useState, useContext, useMemo } from "react";

const SessionContext = createContext({
  isSessionExpired: false,
  setSessionExpired: (expired: boolean) => {},
});

export const useSessionExpiration = () => useContext(SessionContext);

export const SessionExpirationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  const value = useMemo(
    () => ({ isSessionExpired, setSessionExpired: setIsSessionExpired }),
    [isSessionExpired],
  );

  return (
    <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
  );
};
